export const config = {
  version: "1.9.102",
  api: {
    //url: 'http://vm-smarter.brazilsouth.cloudapp.azure.com:30001/', // producción ARGEN
    //url: 'http://digital-minds.com.ar:30001/', // testing  DIGITAL
    url: "http://localhost:35784/", // DEBBUG
    ambientes: [
      { id: "Development", url: "http://localhost:35784/" },
      { id: "Testing - Digital", url: "http://digital-minds.com.ar:30001/" },
      {
        id: "Testing - Argen",
        url: "http://smarter.argenpesos.com.ar:30002/",
      },
      {
        id: "Testing - Argen (https)",
        url: "https://test.smarter.argenpesos.com.ar:30002/",
      },
      {
        id: "Producción (https)",
        url: "https://smarter.argenpesos.com.ar:30010/",
      },
      {
        id: "Producción (api2)",
        url: "http://4.228.15.134:8081/",
      },
    ],
    path: {
      default: "",
      files: "storage/",
    },
  },
};
